import { observer } from 'mobx-react';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import * as React from 'react';
import { SideTitle } from '../SideTitle';
import { getFaqs } from 'utils';
import s from './Faq.scss';
import { FaqItem } from './FaqItem';
import { FaqSideSubtitle } from './FaqSubtitle';

export enum FaqType {
  Default = 'default',
  Enterprise = 'enterprise',
  All = 'all',
}

export interface FaqProps {
  rootStore: RootStore;
  faqType?: FaqType;
}

const FaqsComp: React.FC<FaqProps> = ({
  faqType = FaqType.Default,
  rootStore,
}) => {
  const { theme } = usePageModeContext();
  const { hasGoogleVoucher, country } = rootStore.appStore.appContext;
  const { isFranchPackagePicker, isJapanesePackagePicker } = rootStore.appStore;
  const localizedFaqs = isFranchPackagePicker || isJapanesePackagePicker;

  const getFaqItems = () => {
    const defaultFaqs = getFaqs({
      hasGoogleVoucher,
      theme,
      localizedFaqs,
      country,
    }).map((faq) => (
      <FaqItem key={faq} faqCode={faq} isEnterpriseFaqs={false} />
    ));

    const enterpriseFaqs = getFaqs({
      isEnterprisePlanType: true,
      hasGoogleVoucher,
      theme,
      localizedFaqs,
      country,
    }).map((faq) => (
      <FaqItem key={faq} faqCode={faq} isEnterpriseFaqs={true} />
    ));

    switch (faqType) {
      case FaqType.All: {
        return [...defaultFaqs, ...enterpriseFaqs];
      }
      case FaqType.Enterprise: {
        return enterpriseFaqs;
      }
      default:
        return defaultFaqs;
    }
  };

  const faqs = getFaqItems();

  return (
    <div className={s.faqContainer}>
      <div className={s.innerContainer}>
        <SideTitle titleKey='faq_section.faq_title'>
          <FaqSideSubtitle />
        </SideTitle>
        <div className={s.faqListContainer} data-testid='faq-list'>
          {faqs}
        </div>
      </div>
    </div>
  );
};

export const Faq = withInjectedRootStore(observer(FaqsComp));
